import { set } from "lodash";
function setStateValueSignature(data) {
    console.log(data);
}
export function setStateValue(state, action) {
    var _a = action.payload, key = _a.key, value = _a.value;
    set(state, key, value);
}
//# sourceMappingURL=setStateValue.js.map